'use client';

import { useRef, type CSSProperties, type ReactNode } from 'react';

import {
  HEADER_TRANSITION_DURATION_VAR,
  useHideOnScroll,
} from '@hen-site/app/hooks/useHideOnScroll';

type HideOnScrollHeaderProps = {
  children: ReactNode;
  'data-testid'?: string;
};

const headerStyle: CSSProperties = {
  top: 'var(--hen-admin-toolbar-height, 0px)',
  transitionProperty: 'transform',
  transitionDuration: `var(${HEADER_TRANSITION_DURATION_VAR}, 0ms)`,
  transitionTimingFunction: 'ease-out',
};

/**
 * Sticky site header that scrolls away on scroll down and slides back in
 * on scroll up. `StickyTocNav` detects `data-hide-on-scroll` and docks
 * under the header's visible height instead of its full height.
 */
export function HideOnScrollHeader({
  children,
  'data-testid': testId,
}: HideOnScrollHeaderProps) {
  const ref = useRef<HTMLElement>(null);
  useHideOnScroll(ref);

  return (
    <header
      ref={ref}
      data-site-header
      data-hide-on-scroll
      data-testid={testId}
      className='sticky z-50 will-change-transform'
      style={headerStyle}
    >
      {children}
    </header>
  );
}
